// export const SERVER_URL = "http://localhost:8080" // REST API 서버 Domain URL
export const SERVER_URL = "https://ntek.co.kr" // REST API 서버 Domain URL